export const SIDEBAR_WIDTH_OPEN = 200;
export const SIDEBAR_WIDTH_CLOSED = 50;
export const NAV_BAR_HEIGHT = 48;
export const MOBILE_BREAKPOINT = 770;
export const DRAWER_TRANSITION_MS = 225;
